/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Domain_Search_Modal_Premium_AddonInputs */

const en_domain_search_modal_premium_addon = /** @type {(inputs: Domain_Search_Modal_Premium_AddonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium domain ,  add-on`)
};

const es_domain_search_modal_premium_addon = /** @type {(inputs: Domain_Search_Modal_Premium_AddonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dominio premium, complemento`)
};

const fr_domain_search_modal_premium_addon = /** @type {(inputs: Domain_Search_Modal_Premium_AddonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domaine premium, extension`)
};

const de_domain_search_modal_premium_addon = /** @type {(inputs: Domain_Search_Modal_Premium_AddonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium-Domain, Add-on`)
};

/** @type {(inputs: Domain_Search_Modal_Premium_AddonInputs) => LocalizedString} */
const ja_domain_search_modal_premium_addon = en_domain_search_modal_premium_addon;

/** @type {(inputs: Domain_Search_Modal_Premium_AddonInputs) => LocalizedString} */
const zh_domain_search_modal_premium_addon = en_domain_search_modal_premium_addon;

/** @type {(inputs: Domain_Search_Modal_Premium_AddonInputs) => LocalizedString} */
const ar_domain_search_modal_premium_addon = en_domain_search_modal_premium_addon;

/** @type {(inputs: Domain_Search_Modal_Premium_AddonInputs) => LocalizedString} */
const id_domain_search_modal_premium_addon = en_domain_search_modal_premium_addon;

/** @type {(inputs: Domain_Search_Modal_Premium_AddonInputs) => LocalizedString} */
const it_domain_search_modal_premium_addon = en_domain_search_modal_premium_addon;

/** @type {(inputs: Domain_Search_Modal_Premium_AddonInputs) => LocalizedString} */
const ru_domain_search_modal_premium_addon = en_domain_search_modal_premium_addon;

/** @type {(inputs: Domain_Search_Modal_Premium_AddonInputs) => LocalizedString} */
const pt_domain_search_modal_premium_addon = en_domain_search_modal_premium_addon;

/** @type {(inputs: Domain_Search_Modal_Premium_AddonInputs) => LocalizedString} */
const ko_domain_search_modal_premium_addon = en_domain_search_modal_premium_addon;

/**
* | output |
* | --- |
* | "Premium domain , add-on" |
*
* @param {Domain_Search_Modal_Premium_AddonInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const domain_search_modal_premium_addon = /** @type {((inputs?: Domain_Search_Modal_Premium_AddonInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Domain_Search_Modal_Premium_AddonInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_domain_search_modal_premium_addon(inputs)
	if (locale === "es") return es_domain_search_modal_premium_addon(inputs)
	if (locale === "fr") return fr_domain_search_modal_premium_addon(inputs)
	if (locale === "de") return de_domain_search_modal_premium_addon(inputs)
	if (locale === "ja") return ja_domain_search_modal_premium_addon(inputs)
	if (locale === "zh") return zh_domain_search_modal_premium_addon(inputs)
	if (locale === "ar") return ar_domain_search_modal_premium_addon(inputs)
	if (locale === "id") return id_domain_search_modal_premium_addon(inputs)
	if (locale === "it") return it_domain_search_modal_premium_addon(inputs)
	if (locale === "ru") return ru_domain_search_modal_premium_addon(inputs)
	if (locale === "pt") return pt_domain_search_modal_premium_addon(inputs)
	return ko_domain_search_modal_premium_addon(inputs)
});